var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question"},[_c('div',{staticClass:"inner"},[_c('span',{staticClass:"question-text"},[_vm._t("question")],2),(_vm.selected !== undefined)?_vm._t("default"):_vm._e()],2)])}
var staticRenderFns = []

export { render, staticRenderFns }